module.exports = __webpack_public_path__ + "static/media/honor-original-price-on-variant-exchange-1.b5444388.png";